(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['jquery', 'torso/modules/View', 'templates', 'app/behaviors/PreviewBehavior', 'app/utils/i18nUtils'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var templates = {
      footerTemplate: require('./footerTemplate.hbs')
    };
    module.exports = factory(require('jquery'), require('backbone-torso/modules/View'), templates, require('./../behaviors/PreviewBehavior'), require('./../utils/i18nUtils'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function ($, TorsoView, templates, PreviewBehavior, i18nUtils) {
  'use strict';

  var HOSPITAL_LINK_I18N_KEY = 'footer.hospital.link';
  var CONTACTUS_LINK_I18N_KEY = 'footer.contactUs.link';
  var LEGAL_LINK_I18N_KEY = 'footer.legal.link';
  var PRIVACY_LINK_I18N_KEY = 'footer.privacy.link';

  /**
   * Static View to display portal footer information
   *
   * @class footerView
   * @constructor
   */
  return new (TorsoView.extend({
    tagName: 'footer',
    className: 'brec-page-footer portal-page-footer',
    id: 'page-footer',
    template: templates.footerTemplate,

    behaviors: {
      previewBehavior: PreviewBehavior
    },

    prepareFields: {
      hospitalLink: function() {
        return {
          i18nKey: HOSPITAL_LINK_I18N_KEY,
          hasPropertyValue: i18nUtils.hasPropertyValue(HOSPITAL_LINK_I18N_KEY),
          containsExternalLink: i18nUtils.containsExternalLink(HOSPITAL_LINK_I18N_KEY)
        };
      },
      contactUsLink: function() {
        return {
          i18nKey: CONTACTUS_LINK_I18N_KEY,
          hasPropertyValue: i18nUtils.hasPropertyValue(CONTACTUS_LINK_I18N_KEY),
          containsExternalLink: i18nUtils.containsExternalLink(CONTACTUS_LINK_I18N_KEY)
        };
      },
      legalLink: function() {
        return {
          i18nKey: LEGAL_LINK_I18N_KEY,
          hasPropertyValue: i18nUtils.hasPropertyValue(LEGAL_LINK_I18N_KEY)
        };
      },
      privacyLink: function() {
        return {
          i18nKey: PRIVACY_LINK_I18N_KEY,
          hasPropertyValue: i18nUtils.hasPropertyValue(PRIVACY_LINK_I18N_KEY)
        };
      }
    }
  }))();
}));
